import Dashboard from "@/modules/CRM/pages/Dashboard";
import Funil from "@/modules/CRM/pages/Funil";
import Oportunidades from "@/modules/CRM/pages/Oportunidades";
import OportunidadeDetalhe from "@/modules/CRM/pages/OportunidadeDetalhe";
import Contatos from "@/modules/CRM/pages/Contatos";
import AgendaIndex from "@/modules/CRM/pages/AgendaIndex";
import AgendaVisual from "@/modules/CRM/pages/AgendaVisual";
import AgendaForm from "@/modules/CRM/pages/AgendaForm";
import Tarefas from "@/modules/CRM/pages/Tarefas";
import Relatorios from "@/modules/CRM/pages/RelatoriosOperacionais";
import Configuracoes from "@/modules/CRM/pages/Configuracoes";

export default [
  {
    name: "crmDashboard",
    path: "/crm",
    component: Dashboard,
    meta: { title: "CRM - Visão geral", permission: "crm" },
  },
  {
    name: "crmFunil",
    path: "/crm/funil",
    component: Funil,
    meta: { title: "CRM - Funil", permission: "crm/funil" },
  },
  {
    name: "crmOportunidades",
    path: "/crm/oportunidades",
    component: Oportunidades,
    meta: { title: "CRM - Oportunidades", permission: "crm/oportunidades" },
  },
  {
    name: "crmOportunidadeDetalhe",
    path: "/crm/oportunidades/:id",
    component: OportunidadeDetalhe,
    meta: {
      title: "CRM - Detalhe da Oportunidade",
      permission: "crm/oportunidades",
    },
  },
  {
    name: "crmRelatorioOportunidadeDetalhe",
    path: "/crm/relatorios/oportunidades/:id",
    component: OportunidadeDetalhe,
    meta: {
      title: "CRM - Detalhe da Oportunidade",
      permission: "crm/relatorios",
    },
  },
  {
    name: "crmContatos",
    path: "/crm/contatos",
    component: Contatos,
    meta: { title: "CRM - Clientes e contatos", permission: "crm/contatos" },
  },
  {
    name: "crmAgenda",
    path: "/crm/agenda",
    component: AgendaIndex,
    meta: { title: "CRM - Agenda", permission: "crm/agenda" },
  },
  {
    name: "crmAgendaVisual",
    path: "/crm/agenda/visualizar",
    component: AgendaVisual,
    meta: { title: "CRM - Agenda visual", permission: "crm/agenda" },
  },
  {
    name: "crmAgendaNovo",
    path: "/crm/agenda/novo",
    component: AgendaForm,
    meta: { title: "CRM - Novo agendamento", permission: "crm/agenda" },
  },
  {
    name: "crmAgendaEditar",
    path: "/crm/agenda/:id/editar",
    component: AgendaForm,
    meta: { title: "CRM - Editar agendamento", permission: "crm/agenda" },
  },
  {
    name: "crmTarefas",
    path: "/crm/tarefas",
    component: Tarefas,
    meta: { title: "CRM - Tarefas", permission: "crm/tarefas" },
  },
  {
    name: "crmRelatorios",
    path: "/crm/relatorios",
    component: Relatorios,
    meta: { title: "CRM - Relatórios", permission: "crm/relatorios" },
  },
  {
    name: "crmConfiguracoes",
    path: "/crm/configuracoes",
    component: Configuracoes,
    meta: { title: "CRM - Configurações", permission: "crm/configuracoes" },
  },
];
